(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/coupon-header.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/coupon-header.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.views.CouponHeader = Backbone.Marionette.View.extend({
    modelEvents: {
      'change:system createBaseRow stopBaseRowEdit': 'changeMode'
    },
    regions: {
      matchListHeader: '.maltipset-matchlist-header'
    },
    template: function(data) {
      return svs.maltipset.templates.coupon_header(data);
    },
    onAttach: function() {
      this.setXpertBaseRowHeader();
    },
    initialize: function() {
      if (svs.core.detect.formfactor.mobile()) {
        var self = this;

        this.maxHeight = 54;
        this.minHeight = 30;
        $(window).on('load', function() {
          var scrollHeight, sibling, fixedHeight;
          if (svs.core.detect.feature('ft-maltipset-direct-play')) {
            fixedHeight = svs.components.header.getFixedTopContentWrapperHeight();
            sibling = self.$el.parent()[0].nextElementSibling;
            scrollHeight = self.$el.offset().top - fixedHeight;
          } else {
            fixedHeight = svs.components.header.getFixedTopContentWrapperHeight();
            scrollHeight = self.$el.offset().top - fixedHeight;
          }
          $(window).scroll(function() {
            self.$el
              .parent()
              .toggleClass(
                'coupon-header-sticky stick-to-top coupon-is-scrolled',
                $(this).scrollTop() > scrollHeight
              );
            if (
              svs.core.detect.feature('ft-maltipset-direct-play') &&
              !svs.core.detect.feature('ft-betslip-maltipset')
            ) {
              $(sibling).toggleClass(
                'sticky-padding-top',
                $(this).scrollTop() > scrollHeight
              );
            }
          });
        });
      }
    },
    setXpertBaseRowHeader: function() {
      var sibling = this.$el.parent()[0].nextElementSibling;
      if (svs.core.detect.feature('ft-maltipset-direct-play')) {
        $(sibling).addClass('xpert-base-row-mode');
      }
      if (!this.model.get('xpertBaseRowMode')) {
        this.getRegion('matchListHeader').show(
          new svs.maltipset.views.MatchListHeader({ model: this.model })
        );
        $(sibling).removeClass('xpert-base-row-mode');
      } else if (this.getRegion('matchListHeader').currentView) {
        this.getRegion('matchListHeader').close();
      }
    },
    changeMode: function() {
      this.render();
      this.setXpertBaseRowHeader();
    }
  });
})(Backbone, _, svs);

 })(window);